export namespace DataLayer {
  // ============
  // | Homepage |
  // ============

  export const topTasks = (label: string) =>
    DatalayerApi.push({
      event: 'event',
      category: 'homepage - kunnen wij u helpen',
      action: 'click',
      label: label,
    })

  // ==================
  // | Cookie Consent |
  // ==================

  export const cookies = (event: 'accept' | 'declined' | 'accept_partly') =>
    DatalayerApi.push({
      event: `Cookies: ${event}`,
    })

  // ==========
  // | Footer |
  // ==========

  export const footer = (label: string) =>
    DatalayerApi.push({
      event: 'event',
      category: 'footer',
      action: 'click',
      label: label
    })

  // ======================
  // | Folders overview |
  // ======================

  export const folderFilterEvent = (
    filterType: 'afdeling_filter' | 'search_filter',
    filterValue: string,
    resultCount: number
  ) =>
    DatalayerApi.push({
      event: 'event_sgh',
      event_name: 'filter_click',
      event_cd1: 'sgh_folder_filter',
      event_cd2: filterType,
      event_cd3: filterValue,
      event_cd4: String(resultCount),
      cd_mapping: 'element_type|filter_type|filter_value|result_count',
    })

  export const folderCardView = (title: string, afdeling: string, index: number) =>
    DatalayerApi.push({
      event: 'event_sgh',
      event_name: 'element_view',
      event_cd1: 'sgh_folder_card',
      event_cd2: title,
      event_cd3: afdeling,
      event_cd4: String(index),
      cd_mapping: 'element_type|folder_title|folder_afdeling|card_position',
    })

  export const folderCardClick = (title: string, afdeling: string, index: number) =>
    DatalayerApi.push({
      event: 'event_sgh',
      event_name: 'card_click',
      event_cd1: 'sgh_folder_card',
      event_cd2: title,
      event_cd3: afdeling,
      event_cd4: String(index),
      cd_mapping: 'element_type|folder_title|folder_afdeling|card_position',
    })

  // ====================
  // | Share dossier    |
  // ====================
  export type ShareType = 'whatsapp' | 'email' | 'copy_link'
  export const shareDossier = (shareType: ShareType) =>
    DatalayerApi.push({
      event: 'event',
      category: 'deel_dossier',
      action: 'share',
      label: shareType
    })

  export namespace DatalayerApi {
    interface DataLayerApi {
      push: (data: {}) => void
    }

    export const getDatalayer: () => DataLayerApi | undefined = () =>
      (window as any)['dataLayer'] ? (window as any)['dataLayer'] : undefined

    export const push: (data: any) => void = (data) => {
      const datalayer = getDatalayer()
      if (datalayer) {
        datalayer.push(data)
      } else {
        console.log('--> pushDatalayer: ', data)
      }
    }
  }
}

// ==========================================================================
// Building blocks
// ==========================================================================

export type GTMEvent = {
  event?: string
  category?: string
  action?: string
  label?: string
}

export function datalayerHandler(
  type: string,
  action?: string,
  category?: string,
  blockInfo?: {
    kind?: string
    title?: string
    link?: string
    label?: string
  }
): void {
  let datalayer: GTMEvent = {}

  if (blockInfo) {
    datalayer.label = blockInfo.label
  }

  if (category !== null) {
    datalayer.category = category
  }

  if (action !== null) {
    datalayer.action = action
  }

  if (
    type === 'text' ||
    type === 'text-image' ||
    type === 'cta' ||
    type === 'quote' ||
    type === 'featured' ||
    type === 'link-grid'
  ) {
    // const linkType = isLinkCTA(blockInfo.link)

    // if (linkType.result === false) return

    datalayer.category = type
    datalayer.action = blockInfo?.link || blockInfo?.title || ''
  }

  if (type === 'media') {
    datalayer.label = blockInfo?.link + ' | ' + window.location.pathname
  }

  if (JSON.stringify(datalayer) === '{}') return

  DataLayer.DatalayerApi.push({
    // event: datalayer.event ? datalayer.event : `event.${sitename}`, // TODO declare global sitename variable like in public site?
    event: datalayer.event ? datalayer.event : `event`,
    category: datalayer.category ? datalayer.category : 'BuildingBlock',
    action: datalayer.action ? datalayer.action : 'Click',
    label: datalayer.label ? datalayer.label : window.location.pathname,
  })
}

export type DatalayerEvent = {
  category: string
  action: string
  label?: string
} & OptionalSearchParams &
  OptionalMenuParams &
  OptionalLanguageParams

export type OptionalSearchParams = {
  numberOfResults?: string
}

export type OptionalLanguageParams = {
  language?: string
}

export type OptionalMenuParams = {
  menuType?: 'main' | 'sub' | 'cta' | 'copyright' | 'contact'
}

const defaultParams = {
  event: 'event',
  location: window.location.pathname,
}

export const pushDatalayer = (props: DatalayerEvent) => {
  const params = { ...defaultParams, ...props }
  console.groupCollapsed('pushDatalayer:', params.category)
  console.debug(params)
  console.groupEnd()

  if (window.dataLayer) window.dataLayer.push(params)
}
